import { ProductAdvantagesItemProps } from '@components/Products/ProductDetails/ProductAdvantages/ProductAdvantagesItem/ProductAdvantagesItem'
import {
  ProductDetailsHeaderAdvantage,
  ProductDetailsHeaderProps,
} from '@components/Products/ProductDetails/ProductDetailsHeader'
import { Product } from '@src/types/strapi'

export const makeProductAdvantages = (advantages: Product['advantages']) => {
  const advantagesByType = advantages?.reduce(
    (acc, item) => {
      const advantage = {
        icon: item.icon.url,
        title: item.title,
        description: item.description,
        id: item.id.toString(),
      }

      const arr = item.priority ? acc.advantagesPriority : acc.advantagesNormal
      arr.push(advantage)

      return acc
    },
    {
      advantagesPriority: [] as ProductDetailsHeaderAdvantage[],
      advantagesNormal: [] as ProductAdvantagesItemProps[],
    }
  )

  return (
    advantagesByType || {
      advantagesPriority: [] as ProductDetailsHeaderProps['advantages'],
      advantagesNormal: [] as ProductAdvantagesItemProps[],
    }
  )
}
